// extracted by mini-css-extract-plugin
export default {"companyInsights":"companyInsights_companyInsights__sTDSV","cardFullHeight":"companyInsights_cardFullHeight__wIcxO","pageHeading":"companyInsights_pageHeading__owevq"};